<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Articles - Change Order</div>
                  <p>You can change list ordering by drag and drop !</p>
                </div>
              <div class="col-md-2 offset-md-3 text-right center">
                <router-link to="/admin/resources" class="btn btn-primary" role="button">
                  back
                </router-link>
              </div>
            </div>

          <div class="table-responsive text-center">
            <div class="col-4" v-if="pages.length">
              <fg-select
                v-model="selectedResource"
                label="Page"
                :list="pages"
                selectedKey="id"
              >
              </fg-select>
            </div><br>
            <table class="table table-light table-bordered table-hover">
              <draggable v-model="filteredData" @start="drag=true" @end="drag=false">
                <tr v-for="(item, index) in filteredData" :key="index">
                  <td>{{item.newsResourcesId}}</td>
                  <td>{{getResourceType(item.resourceType)}}</td>
                  <td>{{item.articleHeader}}</td>
                  <td ><img v-if="item.imageUrl" class="table-thumbnail" :title="item.imageUrl":src="item.imageUrl" /></td>
                  <td>
                    <span class="badge badge-success" v-if="item.active"> Active </span>
                    <span class="badge badge-danger" v-else> Inactive </span>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>

          <div class="offset-md-3 col-md-6 text-center">
            <button class="btn btn-primary btn-fill btn-block" @click="updateResourcesListing">
              Update Listings order
            </button>
          </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import draggable from 'vuedraggable'
    const resourceColumns = ['ResourceId', 'Type','Header', 'Image', 'Status', 'Operations'];
    export default {
        name: 'ResourcesSort',
        components: {
            LTable,
            draggable,
        },
        data() {
        return {
          filteredData: [],
          pages: [{id: 1, name:'Featured Article'}, {id: 2, name:'Set the TONE'}],
          pageName: 'UNAUTH',
          selectedResource: 1,
            resources: {
        data: []
        }
      }
    },
      watch: {
          'selectedResource' (to, from) {
            console.log('new resource to search', to)
            this.fetchResources(to)
          }
      },
    methods: {
      getResourceType (typeId) {
        if (typeId === 1) {
          return "Featured Article"
        } else if (typeId === 2) {
          return "Set the TONE"
        } else {
          return "Advertisement"
        }
      },
      updateResourcesListing () {
          let data = this.filteredData;
          let resourceIds = data.map((obj) => {
            return obj.newsResourcesId
          });
          this.$store.dispatch('UPDATE_RESOURCE_ORDERING', {dispOrderArticleIds: resourceIds, resourceType: this.selectedResource})
            .then((res) => {
              console.log("UPDATE_RESOURCE_ORDERING API res : ", res);
              this.$swal('Success!', 'Display order updated successfully', 'success');
              this.$router.push('/admin/resources')
            })
            .catch(err => {
              console.log("UPDATE_LOGOS_ORDERING API error : ", err);
            })
        },
        fetchResources (resourceType) {
            this.$store.dispatch('FETCH_RESOURCES_FOR_SORTING', resourceType)
                    .then((res) => {
                        this.resources.data = res;
                        this.filteredData = res
                        console.log('filtered data', this.filteredData)
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
              this.filteredData = []
                console.log("err : ", err);
            }
        }
    },
    created() {
        this.fetchResources(1);
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Resources/OrderResources.vue